import { useState } from 'react';
import { imageNeedsDarkBackground } from './logo-contrast';

/** Logo seul ; nom de repli en cas d'absence ou d'échec, avec contraste adapté à l'image. */
export function BusinessLogo({
  name,
  logoUrl,
  className = '',
}: {
  readonly name: string;
  readonly logoUrl: string | null;
  readonly className?: string;
}): React.JSX.Element {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const [contrast, setContrast] = useState<{ url: string; darkBackground: boolean } | null>(null);
  return logoUrl && failedUrl !== logoUrl ? (
    <img
      className={`business-logo ${className}${contrast?.url === logoUrl && contrast.darkBackground ? ' is-light' : ''}`}
      src={logoUrl}
      alt={name}
      title={name}
      width="104"
      height="52"
      onLoad={(event) =>
        setContrast({ url: logoUrl, darkBackground: imageNeedsDarkBackground(event.currentTarget) })
      }
      onError={() => setFailedUrl(logoUrl)}
    />
  ) : (
    <span>{name}</span>
  );
}
